import React from 'react'
import Form from './main'

import { useCacheService, getServicesForSelect, getCategoriesForSelect } from '../../../../hooks/cache/service'
import { useCacheUnit, getUnitsIgnoreMTForSelect } from '../../../../hooks/cache/unit'
import { useCacheLanguage, getLanguagesForSelect } from '../../../../hooks/cache/language'
import { useCacheLanguagePair, getLanguagePairsForSelect } from '../../../../hooks/cache/languagePair'

import Loader from '../../../../components/loader'

const Container = (props) => {
  const { data: servicesRaw, isLoading: isServiceLoading, isError: isServiceError } = useCacheService()
  const { data: unitsRaw, isLoading: isUnitLoading, isError: isUnitError } = useCacheUnit()
  const { data: languagesRaw, isLoading: isLanguageLoading, isError: isLanguageError } = useCacheLanguage()
  const { data: languagePairsRaw, isLoading: isLanguagePairLoading, isError: isLanguagePairError } = useCacheLanguagePair()

  const loading = isServiceLoading || isUnitLoading || isLanguageLoading || isLanguagePairLoading
  const error = isServiceError || isUnitError || isLanguageError || isLanguagePairError

  if (loading) {
    return (<Loader loading />)
  }

  if (error) {
    return (<>Error</>)
  }

  const customProps = {
    loading: true,
    loaded: true,
    services: getServicesForSelect(servicesRaw),
    categories: getCategoriesForSelect(servicesRaw),
    languagePairs: getLanguagePairsForSelect(languagePairsRaw),
    languages: getLanguagesForSelect(languagesRaw),
    units: getUnitsIgnoreMTForSelect(unitsRaw)
  }
  return (
    <Form {...customProps} {...props} />
  )
}

export default Container
